import {Component} from "@angular/core";

@Component({
    selector: 'btn-loader',
    templateUrl: './btn-loader.component.html'
})
export class BtnLoaderComponent {

    constructor() { }

}
